import { apiFetch } from "@/lib/api-client";
import type { ChangeDto, SyncRecord, Transaction, TransactionResult } from "@/sync/types";

export type BootstrapResponse = {
	schemaVersion: number;
	workspaceId: string;
	lastSyncId: number;
	models: Record<string, SyncRecord[]>;
};

export type DeltaResponse = { changes: ChangeDto[]; hasMore: boolean; lastSyncId: number };
export type PartialResponse = { lastSyncId: number; records: SyncRecord[] };

type OutgoingTransaction = Pick<Transaction, "id" | "model" | "op" | "modelId" | "data">;

export const getBootstrap = (workspaceId: string) =>
	apiFetch<BootstrapResponse>("/sync/bootstrap", { workspaceId });

export const getDelta = (workspaceId: string, after: number, limit = 500) =>
	apiFetch<DeltaResponse>(`/sync/delta?after=${after}&limit=${limit}`, { workspaceId });

export const getPartial = (workspaceId: string, model: string, projectId: string) =>
	apiFetch<PartialResponse>(
		`/sync/partial?model=${encodeURIComponent(model)}&projectId=${encodeURIComponent(projectId)}`,
		{ workspaceId },
	);

export const postMutations = (workspaceId: string, transactions: OutgoingTransaction[]) =>
	apiFetch<{ results: TransactionResult[] }>("/sync/mutations", {
		method: "POST",
		body: JSON.stringify({ transactions }),
		workspaceId,
	});
